import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="kind"
export default class extends Controller {
	connect() {}

	updateElternStatus({ currentTarget }) {
		const svg = currentTarget.querySelector("svg")
		const hidden_field = currentTarget.querySelector("input")

		if (svg.dataset.ui == "inaktiv") {
			svg.dataset.ui = ""
			hidden_field.value = hidden_field.dataset.elternid
		} else {
			svg.dataset.ui = "inaktiv"
			hidden_field.value = ""
		}
	}
}
